enum FeatureToggle {
  AGENT_CHAT = 'AGENT_CHAT',
  AGENT_CHAT_SUGGESTED_PROMPTS = 'AGENT_CHAT_SUGGESTED_PROMPTS',
  ACTIVE_RX = 'ACTIVE_RX',
  AUDIO_RECORDER = 'AUDIO_RECORDER',
  AUDIO_RECORDER_SUMMARIES = 'AUDIO_RECORDER_SUMMARIES',
  APPOINTMENT_CANCELLATION_REASON = 'APPOINTMENT_CANCELLATION_REASON',
  APPOINTMENT_DIALOG_ADDITIONAL_FIELDS = 'APPOINTMENT_DIALOG_ADDITIONAL_FIELDS',
  APPOINTMENT_RESERVED = 'APPOINTMENT_RESERVED',
  APPOINTMENT_DROP_OFF = 'APPOINTMENT_DROP_OFF',
  AUTO_CWAV_VCR_ROLES_ASSIGN = 'AUTO_CWAV_VCR_ROLES_ASSIGN',
  AUTO_REPLY_RHAPSODY_COMMUNICATION = 'AUTO_REPLY_RHAPSODY_COMMUNICATION',
  AVOID_CUSTOMER_FACING_TASK_DUPLICATE = 'AVOID_CUSTOMER_FACING_TASK_DUPLICATE',
  BREED_UNKNOWN_LAB_WARNING = 'BREED_UNKNOWN_LAB_WARNING',
  AWO_CHARGES_R5_3 = 'AWO_CHARGES_R5_3',
  AWO_CHARGES_R5_5 = 'AWO_CHARGES_R5_5',
  AWO_PMR_RIGHT_RAIL = 'AWO_PMR_RIGHT_RAIL',
  AWO_RIGHT_RAIL_PHASE_2 = 'AWO_RIGHT_RAIL_PHASE_2',
  BUSINESS_ID_URL_PARAM = 'BUSINESS_ID_URL_PARAM',
  BUSINESS_PHONE_NUMBER_RELY_ON_LOCATION = 'BUSINESS_PHONE_NUMBER_RELY_ON_LOCATION',
  CHEWY_PRESCRIPTION_NOTES = 'CHEWY_PRESCRIPTION_NOTES',
  CHEWY_RX_FINALIZATION = 'CHEWY_RX_FINALIZATION',
  CONSOLIDATE_RECORD_DEPOSIT = 'CONSOLIDATE_RECORD_DEPOSIT',
  SEARCH_CATALOG_FILTERS_AND_FACETS = 'SEARCH_CATALOG_FILTERS_AND_FACETS',
  CVC_APPOINTMENT_STATUS_FILTER = 'CVC_APPOINTMENT_STATUS_FILTER',
  CVC_13939_UPDATE_RHAPSODY_NAV = 'CVC_13939_UPDATE_RHAPSODY_NAV',
  CVC_AUTOMATED_APPOINTMENT_NOTIFICATIONS = 'CVC_AUTOMATED_APPOINTMENT_NOTIFICATIONS',
  CVC_DISABLE_ADD_PAYMENT_BUTTON = 'CVC_DISABLE_ADD_PAYMENT_BUTTON',
  CVC_AUTOMATED_GIFT_CARDS = 'CVC_AUTOMATED_GIFT_CARDS',
  CVC_CUMULUS_RHAPSODY_INTEGRATION_PROCEDURES = 'CVC_CUMULUS_RHAPSODY_INTEGRATION_PROCEDURES',
  CVC_CUMULUS_RHAPSODY_INTEGRATION_INVENTORY = 'CVC_CUMULUS_RHAPSODY_INTEGRATION_INVENTORY',
  CVC_CUMULUS_RHAPSODY_INTEGRATION_LABS = 'CVC_CUMULUS_RHAPSODY_INTEGRATION_LABS',
  CVC_INTAKE_QUESTIONNAIRE = 'CVC_INTAKE_QUESTIONNAIRE',
  CVC_PREFILL_QUESTIONNAIRE = 'CVC_PREFILL_QUESTIONNAIRE',
  CVC_QUESTIONS_WORKFLOW = 'CVC_QUESTIONS_WORKFLOW',
  CVC_PREVENT_EMPTY_DEPOSIT = 'CVC_PREVENT_EMPTY_DEPOSIT',
  CVC_ROLES = 'CVC_ROLES',
  CVC_STORE_COLD_VARIATION = 'CVC_STORE_COLD_VARIATION',
  REMINDER_PROTOCOL_SPECIES_FILTERING = 'REMINDER_PROTOCOL_SPECIES_FILTERING',
  DEPOSIT_PAY_BY_LINK = 'DEPOSIT_PAY_BY_LINK',
  DISCHARGE_NOTES_TRANSLATION = 'DISCHARGE_NOTES_TRANSLATION',
  DEPOSIT_JUNE_FF_CVC_19621 = 'DEPOSIT_JUNE_FF_CVC_19621',
  DISCOUNT_ALLOWED_INVENTORY = 'DISCOUNT_ALLOWED_INVENTORY',
  DISCOUNT_ALLOWED_PROCEDURE = 'DISCOUNT_ALLOWED_PROCEDURE',
  DISCOUNT_ALLOWED_LAB_TEST = 'DISCOUNT_ALLOWED_LAB_TEST',
  DISCOUNT_REASON = 'DISCOUNT_REASON',
  // TODO(CVC-31389): Remove after communications right rail is fully rolled out
  ENABLE_COMMUNICATIONS_RIGHT_RAIL = 'ENABLE_COMMUNICATIONS_RIGHT_RAIL',
  ENHANCED_INVENTORY_ORDER_RECEIVING = 'ENHANCED_INVENTORY_ORDER_RECEIVING',
  FOOD_CATALOG = 'FOOD_CATALOG',
  GROUP_CLIENT_SHARING = 'GROUP_CLIENT_SHARING',
  GROUP_DOCUMENTS_SHARING = 'GROUP_DOCUMENTS_SHARING',
  GROUP_QUESTIONS_SHARING = 'GROUP_QUESTIONS_SHARING',
  INPUT_FORMS_DOCUMENT = 'INPUT_FORMS_DOCUMENT',
  LEGACY_FORM_WARNING = 'LEGACY_FORM_WARNING',
  FILTER_UNFINALIZED_SOAP_FROM_MEDICAL_RECORDS = 'FILTER_UNFINALIZED_SOAP_FROM_MEDICAL_RECORDS',
  IMPROVED_SLOT_OVERLAPS = 'IMPROVED_SLOT_OVERLAPS',
  INVENTORY_SUBCATEGORY_FILTERING = 'INVENTORY_SUBCATEGORY_FILTERING',
  INVENTORY_KIB_FILTERS = 'INVENTORY_KIB_FILTERS',
  INVOICE_BASED_REFUNDS = 'INVOICE_BASED_REFUNDS',
  IPO_M2B_BRAINTREE_SIGNUP = 'IPO-M2B_BRAINTREE_SIGNUP',
  IPO_M1_CHECKOUT = 'IPO-M1_CHECKOUT',
  IPO_M1_AUTOSHIP = 'IPO-M1_AUTOSHIP',
  IPO_M1_CHEWY_FREE_SHIPPING = 'IPO-M1_CHEWY_FREE_SHIPPING',
  MEDICAL_HISTORY_LAB_ATTACHMENTS = 'MEDICAL_HISTORY_LAB_ATTACHMENTS',
  MEDICAL_RECORD_DIAGNOSTIC_IMAGERY_PDF = 'MEDICAL_RECORD_DIAGNOSTIC_IMAGERY_PDF',
  MULTI_DEPOSIT_REFUND = 'MULTI_DEPOSIT_REFUND',
  NO_SHOW_CANCELLATION_PENALTY = 'NO_SHOW_CANCELLATION_PENALTY',
  NO_SHOW_CANCELLATION_PENALTY_CARD_ON_FILE_ALERT = 'NO_SHOW_CANCELLATION_PENALTY_CARD_ON_FILE_ALERT',
  NO_SHOW_CANCELLATION_PENALTY_REFUND = 'NO_SHOW_CANCELLATION_PENALTY_REFUND',
  PATIENT_SHARING = 'PATIENT_SHARING',
  PMR_AI_SUMMARIZATION = 'PMR_AI_SUMMARIZATION',
  PREVENT_SCROLL_RESET_ON_APPOINTMENT_CHANGE = 'PREVENT_SCROLL_RESET_ON_APPOINTMENT_CHANGE',
  PREVENT_SCROLL_RESET_ON_SELECTED_DATE_CHANGE = 'PREVENT_SCROLL_RESET_ON_SELECTED_DATE_CHANGE',
  PRICE_MATCH = 'PRICE_MATCH',
  QUESTIONS_DYNAMIC_TEXT_AND_SUBTEXT = 'QUESTIONS_DYNAMIC_TEXT_AND_SUBTEXT',
  RHAP_APPT_TYPE_NAMING_UPDATES = 'RHAP_APPT_TYPE_NAMING_UPDATES',
  REACTIVE_RX = 'REACTIVE_RX',
  READ_ONLY_ANSWER_SECTION_IN_QUESTIONS = 'READ_ONLY_ANSWER_SECTION_IN_QUESTIONS',
  RHAPSODY_GO_STRIPE_INTEGRATION = 'RHAPSODY_GO_STRIPE_INTEGRATION',
  RHAPSODY_PAY_BRAINTREE_INTEGRATION = 'RHAPSODY_PAY_BRAINTREE_INTEGRATION',
  RHAP_UPDATE_REASON_FOR_COMPOUNDING = 'RHAP_UPDATE_REASON_FOR_COMPOUNDING',
  SET_BUNDLE_PRICE = 'SET_BUNDLE_PRICE',
  SET_DEFAULT_SOAP_NOTE_TEMPLATES = 'SET_DEFAULT_SOAP_NOTE_TEMPLATES',
  SIMPLIFY_REMINDER_FLOW_FOR_VCR = 'SIMPLIFY_REMINDER_FLOW_FOR_VCR',
  SIMPLIFY_REMINDER_FLOW_FOR_CVC = 'SIMPLIFY_REMINDER_FLOW_FOR_CVC',
  SMS_CONSENT_TOGGLE = 'SMS_CONSENT_TOGGLE',
  SOAP_CONSENT_FORMS = 'SOAP_CONSENT_FORMS',
  SOURCE_IN_SHIPMENT_TABLE = 'SOURCE_IN_SHIPMENT_TABLE',
  SPACE_MONITOR_MANAGEMENT = 'SPACE_MONITOR_MANAGEMENT',
  SSO_PAYMENT_TERMINALS = 'SSO_PAYMENT_TERMINALS',
  SUPPRESS_ADD_CLIENTS_AND_PATIENTS = 'SUPPRESS_ADD_CLIENTS_AND_PATIENTS',
  TASK_LIST_ORACLE_INTEGRATION = 'TASK_LIST_ORACLE_INTEGRATION',
  TASKS_IMPROVEMENTS_PHASE_1 = 'TASKS_IMPROVEMENTS_PHASE_1',
  TEST_CANARY_COOKIE = 'TEST_CANARY_COOKIE',
  UNLINK_INVOICES = 'UNLINK_INVOICES',
  VACCINATION_DURATION_OF_IMMUNITY_BASED_ON_REMINDER_PROTOCOL = 'VACCINATION_DURATION_OF_IMMUNITY_BASED_ON_REMINDER_PROTOCOL',
  VETCOVE_SETUP = 'VETCOVE_SETUP',
  WP_LINKING_AUTO_RENEWAL = 'WP_LINKING_AUTO_RENEWAL',
  WP_IMPORT_PHASE_1 = 'WP_IMPORT_PHASE_1',
  WPLAN_AUTOMATE_DISCOUNT = 'WPLAN_AUTOMATE_DISCOUNT',
  LAB_INTEGRATION_ACTIONS = 'LAB_INTEGRATION_ACTIONS',
  FOLLOW_UP_QUESTIONS = 'FOLLOW_UP_QUESTIONS',
  SWAP_REACTIVE_RX = 'SWAP_REACTIVE_RX',
  POS_TERMINAL_MIGRATION_TO_VERIFONE = 'POS_TERMINAL_MIGRATION_TO_VERIFONE',
  CVC_SYSTEM_MESSAGE_SUPPRESSION = 'CVC_SYSTEM_MESSAGE_SUPPRESSION',
  CONVERSATION_DIALOG_APPOINTMENT_DROPDOWN = 'CONVERSATION_DIALOG_APPOINTMENT_DROPDOWN',
  PDMP_REPORTING_REQUIRED = 'PDMP_REPORTING_REQUIRED',
  MESSAGE_CLIENT_USE_NEW_CONVERSATION_DIALOG = 'MESSAGE_CLIENT_USE_NEW_CONVERSATION_DIALOG',
  MEMBERSHIP_AUTO_CANCEL = 'MEMBERSHIP_AUTO_CANCEL',
  MEMBERSHIP_CANCELLATION_ENHANCEMENTS = 'MEMBERSHIP_CANCELLATION_ENHANCEMENTS',
  FE_DVM_LICENSE_STATE_MATCHING = 'FE_DVM_LICENSE_STATE_MATCHING',
  FE_DVM_LICENSE_STATE_VALIDATION = 'FE_DVM_LICENSE_STATE_VALIDATION',
  RHAP_RX_STATUS_TRACKER = 'RHAP_RX_STATUS_TRACKER',
  RX_TRACKER_PHASE_1 = 'RX_TRACKER_PHASE_1',
  PMR_NEW_APPOINTMENT = 'PMR_NEW_APPOINTMENT',
  CVC_SHOW_COMMUNICATION_WIDGET = 'CVC_SHOW_COMMUNICATION_WIDGET',
  SUPPRESS_ALL_SYSTEM_MESSAGES = 'SUPPRESS_ALL_SYSTEM_MESSAGES',
  MARK_MESSAGES_AS_MEDICAL = 'MARK_MESSAGES_AS_MEDICAL',
  USE_RHAPSODY_THEME = 'USE_RHAPSODY_THEME',
  VCR_IMPROVEMENT_IN_TASK_FLOW = 'VCR_IMPROVEMENT_IN_TASK_FLOW',
  LOGICAL_SMS_THREADING = 'LOGICAL_SMS_THREADING',
  DISPLAY_COMMUNICATION_SENDER_CVC_TITLE = 'DISPLAY_COMMUNICATION_SENDER_CVC_TITLE',
}

export default FeatureToggle
